export const TERMINOS_VERSION = '2026-07-04';

export const TERMINOS_TITULO = 'Declaración jurada de autorización de venta';

export const TERMINOS_TEXTO =
  'Declaro bajo juramento que los datos consignados son correctos y completos, ' +
  'que soy titular o apoderado autorizado de la cuenta indicada y que autorizo expresamente ' +
  'a la cooperativa a descontar de mi disponibilidad los kilogramos detallados, ' +
  'conforme a las condiciones de precio y vencimiento seleccionadas. ' +
  'Reconozco que esta firma electrónica constituye manifestación fehaciente de mi voluntad ' +
  'y acepto que la cooperativa conserve este registro con fines probatorios.';

export function buildDeclaracionResumen(grano: string, kilos: number): string {
  return (
    'Autorizo la venta de ' +
    String(kilos) +
    ' kg de ' +
    grano +
    ' en los términos indicados arriba.'
  );
}
